import { useState } from "react";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function PasswordInputBase({
  value,
  onChange,
  disabled,
  placeholder,
  ...otherProps
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputBase
      required
      fullWidth
      sx={{
        padding: 2,
        maxWidth: 360,
        color: "grey.600",
        fontStyle: "italic",
        borderRadius: "12px",
        backgroundColor: "grey.900",
      }}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type={showPassword ? "text" : "password"}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            edge="end"
            size="small"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
      {...otherProps}
    />
  );
}

export default PasswordInputBase;
